import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import { FeatureFlags } from 'UI/constants/featureFlags';

export const useContactProfileFeatureFlags = () => {
  const { checkIfFeatureFlagEnabled } = useFeatureFlags();

  return {
    canOrganizeTabs: checkIfFeatureFlagEnabled(FeatureFlags.OrganizeTabsContactProfile),
    isAddDailyPlanTaskEnabled: checkIfFeatureFlagEnabled(FeatureFlags.DailyPlanAddTaskFromProfile),
    isChangeLogsTabEnabled: checkIfFeatureFlagEnabled(FeatureFlags.ChangeLogContact),
    isEnabledAddAsACandidate: checkIfFeatureFlagEnabled(FeatureFlags.NewCandidateFromContact),
    shouldShowKeywords: checkIfFeatureFlagEnabled(FeatureFlags.ContactKeywordTags)
  };
};
